import {intersectionObserve} from "./_intersection-observer";

var $stickyHeader = $('.field-banner .sticky-info');
var $banner = $('.field-banner .banner-info .title');
if ($banner.length > 0) {
    intersectionObserve($banner[0], 0, function(element, intersectionRatio) {
        if (intersectionRatio > 0) {
            $stickyHeader.removeClass('show small');
        } else {
            $stickyHeader.addClass('show');
        }
    });

    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop();

        if (scrollTop < $banner.height()) {
            $stickyHeader.removeClass('show');
        }
    });
}
